export default __webpack_public_path__ + "assets/images/0d104b8f970a80c52386ab6b973b11f0.png";